/*
Documentation

this reducer holds all the actions we can dispatch for our global user object

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    alerts: {
        show:     false,
        text:     null,
        type:     null,
    },
    login_redirect: '',
    loader: false,
    standardLoader: false,
    alertBS: {
        error: false,
        text: null
    },
    archk_alerts: [],
    selected_case: null,
    bk_pct_documents: 0,
    bk_pct_questionnaire: 0,
    bk_pct_credit_counseling: 0,
    zap_access: {
        access_code: '',
        identifier: '',
        err: false,
    },
    contact_alerts: []
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SELECT_CASE:

            const _case = action.payload;

            let bk_pct_documents = 0;
            let bk_pct_questionnaire = 0;
            let bk_pct_credit_counseling = 0;
            let bk_pct_total = 0;

            if(_case && _case.missing_docs) {

                const filterSpecialDocs = (docs) => docs.filter(doc => doc.name !== 'Questionnaire' && doc.name !== 'Questionnaire ' && doc.name !== 'Credit Counseling Certificate');

                let _questionnaireDoc = _case.missing_docs.find(d => d.name === 'Questionnaire' || d.name === 'Questionnaire ');
                let _creditCounselingDoc = _case.missing_docs.find(d => d.name === 'Credit Counseling Certificate');

                if(!_questionnaireDoc || _questionnaireDoc.status === 'completed') {
                    bk_pct_questionnaire = 100;
                    bk_pct_total += 33.33;
                }
                if(!_creditCounselingDoc || _creditCounselingDoc.status === 'completed') {
                    bk_pct_credit_counseling = 100;
                    bk_pct_total += 33.33;
                }
    
                const filteredDocs = filterSpecialDocs(_case.missing_docs)

                let completedDocs = 0;

                filteredDocs.forEach(doc => {
                    if(doc.status === 'n/a' || doc.status === 'completed') {
                        completedDocs++;
                    }
                })

                if(completedDocs) {
                    bk_pct_documents = Math.floor((completedDocs / filteredDocs.length) * 100)
                    bk_pct_total += bk_pct_documents * .3333
                } 
                
                if(!filteredDocs.length) {
                    bk_pct_documents = 100
                    bk_pct_total += bk_pct_documents * .3333
                }
            }

            if(bk_pct_total > 99.5) bk_pct_total = 100;

            bk_pct_total = Math.floor(bk_pct_total)

            return {
                ...state,
                selected_case: _case,
                bk_pct_documents,
                bk_pct_questionnaire,
                bk_pct_credit_counseling,
                bk_pct_total,
                zap_access: {
                    access_code: '',
                    identifier: '',
                    err: false,
                },
                contact_alerts: []
            }
            
        case actionTypes.SET_ZAP_ACCESS:

            return {
                ...state,
                zap_access: {
                    access_code: action.payload.access_code,
                    identifier: action.payload.identifier,
                    err: action.payload.err,
                }
            }
      
        case actionTypes.SET_CONTACT_ALERTS:

            return {
                ...state,
                contact_alerts: action.payload
            }
      
        case actionTypes.TOGGLE_SYSTEM_ALERT:

            return {
                ...state,
                alerts: {
                    show: action.payload.boolean,
                    text: action.payload.text,
                    type: action.payload.type,
                }
            }

        case actionTypes.TOGGLE_SYSTEM_LOADER:

            return {
                ...state,
                loader: action.payload,
            }

        case actionTypes.SET_LOGIN_REDIRECT:

            return {
                ...state,
                login_redirect: action.payload,
            }

        case actionTypes.TOGGLE_STANDARD_LOADER:

            return {
                ...state,
                standardLoader: action.payload,
            }
        
        case actionTypes.SET_ARCHK_ALERTS:

            return {
                ...state,
                archk_alerts: action.payload,
            }

        case actionTypes.TOGGLE_SYSTEM_ALERT_BS:

            if(action.payload && action.payload.error !== undefined && action.payload.text) {

                return {
                    ...state,
                    alertBS: {
                        error: action.payload.error,
                        text: action.payload.text,
                    }
                }

            } else {

                return {
                    ...state,
                    alertBS: null
                }

            }

        default:

            return state;

    }

}

export default reducer;
